e360.controller('EditParticipantController',
   ['$scope', '$window', 'participantsApi', 'eventsApi', 'surveyItemsApi', '$stateParams', 'utils', 'toast', 'loader', 'titleService', 'session', 'GuestTypeService',
      function ($scope, $window, participantsApi, eventsApi, surveyItemsApi, $stateParams, utils, toast, loader, titleService, session, guestTypeService) {
         var members = {};

         titleService.setTitle('Participant Management');
         $scope.participant = { country: 'US' };
         $scope.loader = loader;

         $scope.onPickPlace = function(place) {
            $scope.participant.city = place.city;
            $scope.participant.state = place.stateCode;
            $scope.participant.country = place.countryCode;
         };

         members.initialize = function () {
            loader.hide();
            $scope.isInitializing = true;
            $scope.defaultLanguage = session.getCampaign().defaultLanguage;

            guestTypeService.list(session.getCampaign().id).then(function(guestTypes) {
               $scope.guestTypes = guestTypes;
            });

            if ($scope.isEditMode()) {
               members.getParticipant($stateParams.id);
            } else if ($stateParams.eventId) {
               members.getEvent($stateParams.eventId);
            } else {
               $scope.isInitializing = false;
            }
         };

         members.getParticipant = function (id) {
            participantsApi.get(id).then(function (data) {
               $scope.participant = data;
               if (data.dateOfBirth) {
                  $scope.participant.dateOfBirth = moment(data.dateOfBirth).format('MM/DD/YYYY');
               }

               $scope.qrUrl = utils.getQRUrl({wbid: $scope.participant.wristBandId, imageOnly: true});
               members.getEvent(data.eventId);

               _.each(data.surveyResults, function(survey) {
                  if (survey.surveyItem.type == 'Multioption') {
                     survey.choices = survey.value.split(',');
                  }
               });

               return surveyItemsApi.list(session.getBrand().id);
            }).then(function (data) {
               // Reduce survey array to dict object
               $scope.surveyItems = _.reduce(data, function(map, obj) {
                  // Reduce choice array to dict object
                  obj.surveyItemChoices = _.reduce(obj.surveyItemChoices, function(m, o) {
                     m[o.key] = o;
                     return m;
                  }, {});

                  // Multi select is simpler using the choice keys since the choice is saved differently than the
                  // data model of the survey & choices themselves
                  if (obj.type == 'Multioption') {
                     obj.choices = [];
                     _.each(obj.surveyItemChoices, function(choice) {
                        obj.choices.push(choice.key);
                     });
                  }

                  map[obj.id] = obj;
                  return map;
               }, {});
            });
         };

         members.getEvent = function (eventId) {
            eventsApi.get(eventId).then(function(event) {
               $scope.participant.event = event;
            }).finally(function() {
               $scope.isInitializing = false;
            });
         };

         $scope.isEditMode = function () {
            return $stateParams.id;
         };

         $scope.goBack = function () {
            $window.history.back();
         };

         $scope.preventQRCodeLinkIfEmpty = function ($event) {
            if (!$scope.participant.wristBandId) {
               $event.preventDefault();
            }
         };

         $scope.save = function () {
            var invalidPhone = $('input.ng-invalid-international-phone-number');
            if (invalidPhone && invalidPhone.length > 0) {
               toast.error().message('Please enter a valid phone number').send();
               return;
            }

            $scope.$broadcast('phone.save.pre', true);

            var dto = angular.copy($scope.participant);

            dto.eventId = dto.event ? dto.event.id : null;

            if (dto.dateOfBirth) {
               dto.dateOfBirth = utils.toServerDateTime(dto.dateOfBirth, "MM/DD/YYYY");
            }

            if (!dto.email) {
               dto.email = null;
            }

            _.each(dto.surveyResults, function(res) {
               if (res.choices) {
                  res.value = res.choices.join(',');
                  delete res.choices;
               }
            });

            var promise, message;
            if ($scope.isEditMode()) {
               message = 'Participant saved!';
               promise = participantsApi.update(dto);
            } else {
               message = 'Participant created!';
               promise = participantsApi.create(dto);
            }

            loader.showSpinner();
            promise.then(function (data) {
               $scope.goBack();
               toast.success()
                  .message(message)
                  .send();
            })['finally'](function () {
               loader.hide();
               $scope.$broadcast('phone.save.post', true);
            });
         };

         members.initialize();

      }]);
